import {setDebugTraces} from './debug_traces'

const privateApi = {
  setDebugTraces,
}

// public object
export const PRIVATE_API_DO_NOT_TOUCH_NO_SEMVER_SUPPORT = privateApi
